import React from "react";
import { Alert, Button, Modal } from "react-bootstrap";
import PlantedAcresCard from "./PlantedAcresCard";
import SiteCard from "../sites/SiteCard";
import EmptyPlantedAcres from "./EmptyPlantedAcres";
import { useSelector } from "react-redux";
import { setSelectedPlantedAcre } from "reduxStore/slices/plantedAcresSlice";
import { setPlantedAcres } from "reduxStore/slices/plantedAcresSlice";
import { setSelectedSite } from "reduxStore/slices/siteSlice";
import { useDispatch } from "react-redux";
import CardSkeleton from "components/common/CardSkeleton";
import { setEditedPlantedAcre } from "reduxStore/slices/plantedAcresSlice";
import { Link, useNavigate } from "react-router-dom";

const MapPlantedAcres = ({
  onAddPlantedAcres,
  onEditPlantedAcre,
  onShowTimeline,
  onDeletePlantedAcre,
  onShareSite,
  onEditSite,
  onDeleteSite,
  onStopShareSite,
  onShowSiteNotes,
  onShowPlantedAcresNotes,
  isLoading,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const selectedSite = useSelector((state) => state.site.selectedSite);
  const plantedAcres = useSelector((state) => state.plantedAcres.plantedAcres);

  const handlePlantedAcreClick = (selectedPlantedAcre) => {
    if (selectedSite && selectedSite.id) {
      dispatch(setSelectedPlantedAcre(selectedPlantedAcre));
      navigate(
        `/sites/${selectedSite.id}/planted-acres/${selectedPlantedAcre.id}`,
        { state: { fromMap: true } }
      );
    }
  };

  const onClose = () => {
    dispatch(setSelectedSite(null));
    dispatch(setSelectedPlantedAcre(null));
    dispatch(setPlantedAcres(null));
    dispatch(setEditedPlantedAcre(null));
  };

  const handleAddPlantedAcres = () => {
    dispatch(setEditedPlantedAcre(null));
    onAddPlantedAcres();
  };

  if (!selectedSite) {
    return null;
  }

  return (
    <Modal
      show={!!selectedSite}
      onHide={onClose}
      centered
      size="md"
      fullscreen="md-down"
      className="planted-acres-popup"
    >
      <Modal.Header closeButton className="pb-0">
        <div className="d-flex flex-column w-100">
          <Modal.Title className="mb-2">Site Details</Modal.Title>
          <div className="header-card-shadow rounded">
            <SiteCard
              type={
                selectedSite.isShared
                  ? "title-shared-site-card"
                  : "title-site-card"
              }
              site={selectedSite}
              onSiteClick={() => {}}
              onShareSite={onShareSite}
              onEditSite={onEditSite}
              onDeleteSite={onDeleteSite}
              onStopShareSite={onStopShareSite}
              onShowNotes={onShowSiteNotes}
            />
          </div>
          <Alert variant="warning" className="site-details-note">
            The listed details are for the current year. For additional filters,
            please visit the Planted Acres page in{" "}
            <Link to={`/sites/${selectedSite.id}/planted-acres`}>
              List View
            </Link>
          </Alert>
        </div>
      </Modal.Header>
      <Modal.Body className="p-3">
        {isLoading ? (
          <CardSkeleton numberOfCards={2} />
        ) : plantedAcres && plantedAcres.length > 0 ? (
          <>
            <div className="d-flex justify-content-between align-items-center">
              <h6 className="my-0">List of Planted Acres</h6>
              <Button
                variant="outline-dark"
                size="sm"
                className="rounded-pill"
                onClick={handleAddPlantedAcres}
              >
                <i className="fa fa-circle-plus me-1"></i> Planted Acres
              </Button>
            </div>
            <div className="planted-acres-map-list">
              {plantedAcres.map((plantedAcre, index) => (
                <div key={index} className="mb-3">
                  <PlantedAcresCard
                    type="planted-acres-card"
                    plantedAcre={plantedAcre}
                    handlePlantedAcreClick={() =>
                      handlePlantedAcreClick(plantedAcre)
                    }
                    onEditPlantedAcre={onEditPlantedAcre}
                    onShowTimeline={onShowTimeline}
                    onShowNotes={onShowPlantedAcresNotes}
                    onDeletePlantedAcre={onDeletePlantedAcre}
                  />
                </div>
              ))}
            </div>
          </>
        ) : (
          <EmptyPlantedAcres onAddPlantedAcres={onAddPlantedAcres} />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default MapPlantedAcres;
